export default {
  'X-Frame-Options': 'SAMEORIGIN',
  'Content-Security-Policy': null,
};
